import { SIDEBAR_EDIT_CONTENT_KEY } from "fleet/constant/sidebar";
import {
  changePriorityOrderAction,
  deleteSpotAction,
} from "fleet/redux-store/ui-state/strategy-v2";
import { SpotTable } from "fleet/view/strategy-v2/spot-table";
import { connect } from "react-redux";
import {
  hideSidebarAction,
  setActiveKeySidebarAction,
} from "redux-store/ui-state/sidebar";

const baseStorePath = "pages.strategyDetail.strategy";

function mapDispatchToProps(dispatch) {
  return {
    changePriorityOrder: (payload) => {
      dispatch(changePriorityOrderAction(payload));
    },
    deleteSpot: (payload) => {
      dispatch(deleteSpotAction(payload));
    },
    showSidebar: (priority, rowIdx) => {
      const storePath = `${baseStorePath}.${priority}.${rowIdx}`;

      dispatch(
        setActiveKeySidebarAction(
          SIDEBAR_EDIT_CONTENT_KEY,
          "File Details",
          null,
          storePath,
        ),
      );
    },
    hideSidebar: () => {
      dispatch(hideSidebarAction);
    },
  };
}

const ConnectedSpotTable = connect(null, mapDispatchToProps)(SpotTable);

export { ConnectedSpotTable };
